import styled, { css } from 'styled-components';
import { layout } from '@prisjakt/ui-base';
import DropdownComponent from '@prisjakt/ui-dropdown-new';
import DropdownItemComponent from '@prisjakt/ui-dropdown-new/src/item';

export const Dropdown = styled(DropdownComponent)`
  max-width: 260px;
  margin-bottom: ${layout.spacing.xSmall};
`;

export const DropdownToggle = styled.div`
  display: flex;
`;

export const DropdownItem = styled(DropdownItemComponent)(
  props => css`
    width: 100%;
  `
);

export const SelectedDropdownItem = styled.span`
  color: ${p => p.theme.text.callToAction};
  font-weight: 600;
  margin-left: ${layout.spacing.xSmall};
`;
